import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './TemplateHeader10.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader10 = ({ branding, mode, templateId, headerMenu = [], onNavigate }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const logoUrl = branding?.logoUrl || user?.logo;
  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName = branding?.brandName || user?.brandName || "Travel Agency";

  const handleNavClick = (e, item) => {
    const viewName = item.path === "/" ? "home" : item.path.replace('/', '');

    // BUILDER MODE
    if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    }
    // PREVIEW MODE
    else if (mode === "preview") {
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // LIVE MODE
    else {
      // Let Link navigate normally
    }

    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>

      {/* Scanner Animation Line */}
      <div className={styles.scannerLine}></div>

      <div className={styles.mainContainer}>

        {/* LOGO SECTION */}
        <div className={styles.logoLens}>
          <Link
  to="/"
  onClick={(e) => {
    e.preventDefault(); // 🔥 stops navigation
    handleNavClick(e, { path: "/" });
  }}
>
            {logoUrl ? (
              <img src={logoUrl} alt={brandName} className={styles.logoImage} />
            ) : (
              <h2 className={styles.textLogo}>{brandName}</h2>
            )}
          </Link>

          <div className={styles.lensOrbit}></div>
        </div>

        {/* RIGHT SECTION */}
        <div className={styles.rightSection}>

          <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
            <ul className={styles.navList}>
              {headerMenu.map((item) => (
                <li key={item.id} className={styles.navItem}>
                  <Link
                    to={item.path}
                    onClick={(e) => handleNavClick(e, item)}
                    className={styles.navLink}
                  >
                    <span className={styles.navHoverBg}></span>
                    <span className={styles.label}>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.ctaContainer}>
            <button className={styles.bookBtn}>
              <span className={styles.btnGlitch}></span>
              <span className={styles.btnText}>Book Now</span>
            </button>
          </div>

          <div
            className={styles.mobileToggle}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </div>

        </div>
      </div>

      {/* Structural Decoration */}
      <div className={styles.bottomFrame}>
        <div className={styles.frameNode}></div>
        <div className={styles.frameLine}></div>
      </div>

    </header>
  );
};

export default TemplateHeader10;